import { StringParam, useQueryParams } from 'use-query-params'

import { useDidMountEffect, useQueryList } from '@percent/partner-dashboard/common/hooks'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import { UsersTable } from './usersTable/UsersTable'

export function UsersContainer() {
  const { iamService } = useServices()

  const [queryParams, setQueryParams] = useQueryParams(
    {
      search: StringParam
    },
    {}
  )

  const [
    { data: usersData, totalResults: totalUsers, isLoading: isLoadingUsers },
    { query: queryUsers, nextPage: nextPageUsers, previousPage: previousPageUsers, refresh: refreshUsers }
  ] = useQueryList(iamService.getAccounts, { search: queryParams.search ?? undefined })

  useDidMountEffect(
    () => queryUsers({ search: queryParams.search ?? undefined, cursor: undefined }),
    [queryParams.search, queryUsers]
  )

  return (
    <UsersTable
      data={usersData}
      totalResults={totalUsers}
      isLoading={isLoadingUsers || !usersData}
      nextPage={nextPageUsers}
      previousPage={previousPageUsers}
      refresh={refreshUsers}
      queryParams={queryParams}
      setQueryParams={setQueryParams}
    />
  )
}
